
export default function minMax(min: number, n: number, max: number): number
{
	if (n <= min)
		return min;
	if (n >= max)
		return max;
	return n;
}
